import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

const BASE =
  'inline-flex items-center gap-1 whitespace-nowrap rounded-[6px] px-[7px] py-0.5 font-mono text-[11px] font-semibold tracking-[0.02em] no-underline';

/**
 * Design `.tg`: a mono 11px square-cornered tag (ground / muted-2). `tone="mist"` is the set-link
 * variant (mist fill); with `to` it renders a router link that darkens on hover (`a.tg:hover`).
 */
export default function Tag({ children, to, tone = 'default', className = '' }: {
  children: ReactNode;
  to?: string;
  tone?: 'default' | 'mist';
  className?: string;
}) {
  const fill = tone === 'mist' ? 'bg-mist text-muted-2' : 'bg-ground text-muted-2';
  if (to) {
    return (
      <Link to={to} className={`${BASE} ${fill} hover:bg-mist hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent ${className}`}>
        {children}
      </Link>
    );
  }
  return <span className={`${BASE} ${fill} ${className}`}>{children}</span>;
}
